import { render } from "./TablePage.vue?vue&type=template&id=53f6777c&scoped=true"
import script from "./TablePage.vue?vue&type=script&lang=js"
export * from "./TablePage.vue?vue&type=script&lang=js"

import "./TablePage.vue?vue&type=style&index=0&id=53f6777c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f6777c"]])

export default __exports__